import * as React from 'react';
import moment from 'moment';
import { BsCheckCircleFill } from 'react-icons/bs';
import { FaUserClock, FaUserTie } from 'react-icons/fa';
import { ImCancelCircle } from 'react-icons/im';
import { IoIosCreate } from 'react-icons/io';
import { MdDateRange } from 'react-icons/md';
import { IoChevronDown, IoPencil, IoClose, IoCalendarOutline } from 'react-icons/io5';
import { toast } from 'react-toastify';
import { deleteLeaveRequestById, getAllLeaveType, getMyLeaveApprovals, getMyLeaveRequestsWithSearch, logout, stringAvatar, submitLeaveRequestAction } from '../../../service/service-call';
import LeaveRequestAction from './LeaveRequestAction';
import LeaveRequestEdit from './LeaveRequestEdit';
import {
  Modal,
  ModalDialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Table,
} from "@mui/joy";

function InitialsAvatar({ name, size = 36 }) {
  const { sx, children } = stringAvatar(name) || {};
  const bg = sx?.bgcolor || "#262673";
  return (
    <div
      style={{ width: size, height: size, backgroundColor: bg }}
      className="flex shrink-0 items-center justify-center rounded-full text-xs font-bold text-white shadow-sm"
    >
      {children}
    </div>
  );
}

const statusStyles = {
  APPROVED: "bg-green-500",
  REQUESTED: "bg-orange-500",
  REJECTED: "bg-red-500",
};

const timelineIcons = {
  REQUESTED: <IoIosCreate size={16} />,
  REJECTED: <ImCancelCircle size={16} />,
  APPROVED: <BsCheckCircleFill size={16} />,
  PENDING_ADMIN: <FaUserClock size={16} />,
  PENDING_SUPER_ADMIN: <FaUserTie size={16} />,
};

const leaveHistoryRows = (leaves) => [
  ["Total Leaves", leaves.allocatedLeaves],
  ["Used Leaves", leaves.usedLeaves],
  ["Available Leaves", leaves.availableLeaves],
  ["Upcoming approved Leaves", leaves.upcomingApprovedLeaves],
  ["Requested Leaves", leaves.requestedLeaves],
  ["Available Permission", leaves.availablePermissionsThisMonth],
  ["Used Permission", leaves.usedPermissionsThisMonth],
  ["Upcoming approved permission", leaves.upcomingApprovedPermission],
  ["Requested permission", leaves.requestedPermission],
  ["Available compensation leaves", leaves.availableCompensationLeaves],
  ["Used compensation leaves", leaves.usedCompensationLeaves],
  ["Requested compensation leaves", leaves.requestedCompensationLeaves],
  ["Upcoming approved compensation leaves", leaves.upComingApprovedCompensationLeaves],
];

export default function LeaveApprovals() {
  const [searchText, setSearchText] = React.useState("");
  const [allLeaveTypes, setAllLeaveTypes] = React.useState([]);
  const [selectedLeaveTypeId, setSelectedLeaveTypeId] = React.useState("");
  const [selectedLeaveType, setSelectedLeaveType] = React.useState("");
  const [allLeaveRequests, setAllLeaveRequests] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [expanded, setExpanded] = React.useState(-1);
  const [selectedId, setSelectedId] = React.useState("");
  const [reqStatus, setReqStatus] = React.useState("");
  const [isAddTeamOpen, setIsAddTeamOpen] = React.useState(false);
  const [isEditLeaveRequestOpen, setIsEditLeaveRequestOpen] = React.useState(false);
  const [isLeaveRequestActionOpen, setIsLeaveRequestActionOpen] = React.useState(false);
  const [sdate, setSDate] = React.useState(null);
  const [edate, setEDate] = React.useState(null);
  const [selectedStatus, setSelectedStatus] = React.useState("");
  const [selectedApprovalId, setSelectedApprovalId] = React.useState("");
  const [leaveHistoryOpen, setLeaveHistoryOpen] = React.useState(false);
  const [selectedLeaves, setSelectedLeaves] = React.useState(null);
  const handleExpandClick = (i) => {
    setExpanded(expanded === i ? -1 : i);
  };

  React.useEffect(() => {
    getAllLeaveTypes();
    getAllLeaveRequests(searchText);
  }, []);

  function getAllLeaveTypes() {
    getAllLeaveType("").then(resp => {
      if (resp.status === 401) {
        logout();
      }
      resp.json().then(data => {
        let arr = data.filter(function (item) {
          return item.name !== "GOVERNMENT_LEAVE"
        })
        setAllLeaveTypes(arr);
      });
    }).catch(error => {
      console.log("login user err " + error);
    });
  }

  function getAllLeaveRequests(value) {
    setIsLoading(true);
    getMyLeaveApprovals(value).then(resp => {
      setIsLoading(false);
      if (resp.status === 401) {
        logout();
      }
      resp.json().then(data => {
        setAllLeaveRequests(data);
      });
    }).catch(error => {
      console.log("login user err " + error);
    });
  }

  const handleEDateChange = (e) => {
    setEDate(moment(e).format("YYYY-MM-DD"))
  }

  const handleSDateChange = (e) => {
    setSDate(moment(e).format("YYYY-MM-DD"))
  }

  const handleReqStatusChange = (e) => {
    setReqStatus(e.target.value);
  }

  function toggleAddTeamModal() {
    setIsAddTeamOpen(!isAddTeamOpen);
    if (isAddTeamOpen === true) {
      getAllLeaveRequests(searchText);
    }
  }

  function toggleEditLeaveRequestModal() {
    setIsEditLeaveRequestOpen(!isEditLeaveRequestOpen);
    if (isEditLeaveRequestOpen === true) {
      getAllLeaveRequests(searchText);
    }
  }

  function toggleLeaveRequestActionModal() {
    setIsLeaveRequestActionOpen(!isLeaveRequestActionOpen);
    if (isLeaveRequestActionOpen === true) {
      setExpanded(null);
      getAllLeaveRequests(searchText);
    }
  }

  function addNewLeaveRequests() {
    toggleAddTeamModal();
  }

  function editLeaveRequest(id) {
    setSelectedId(id);
    toggleEditLeaveRequestModal();
  }

  function deleteLeaveRequest(id) {
    deleteLeaveRequestById(id).then(resp => {
      toast.success('Leave Request deleted successfully');
      getAllLeaveRequests(searchText);
    }).catch(error => {
      if (error && error.response && error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
        toast.error(error.response.data.errors[0]);
      } else {
        toast.error("Internal server error, contact support team");
      }
    })
  }

  function leaveRequestActionClick(status, id) {
    setSelectedStatus(status);
    setSelectedApprovalId(id);
    toggleLeaveRequestActionModal();
  }

  function searchLeaveRequests() {
    setIsLoading(true);
    getMyLeaveRequestsWithSearch(sdate, edate, selectedLeaveTypeId, reqStatus).then(resp => {
      setIsLoading(false);
      if (resp.status === 401) {
        logout();
      }
      resp.json().then(data => {
        setAllLeaveRequests(data);
      });
    }).catch(error => {
      console.log("login user err " + error);
    });
  }

  const approveLeaveRequestActionClick = (approvalId) => {
    submitLeaveRequestAction(approvalId, "APPROVED", null).then(resp => {
      setExpanded(null);
      toast.error('Leave request approved successfully');
      getAllLeaveRequests(searchText);
    }).catch(error => {
      if (error && error.response && error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
        toast.error(error.response.data.errors[0]);
      } else {
        toast.error("Internal server error, contact support team");
      }
    })
  }

  return (
    <div>
      {/* Loading */}
      {isLoading && (
        <div className="flex items-center justify-center py-10">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-[#262673]" />
        </div>
      )}

      {/* List */}
      {!isLoading && (
        <div className="max-h-[600px] space-y-4 overflow-y-auto pr-1">
          {allLeaveRequests.length === 0 && (
            <div className="flex flex-col items-center justify-center gap-2 rounded-2xl border border-dashed border-gray-200 py-16 text-gray-400">
              <IoCalendarOutline size={26} className="text-gray-300" />
              <p className="text-sm font-medium">No records found</p>
            </div>
          )}

          {allLeaveRequests.length > 0 && allLeaveRequests.map((each, index) => {
            const isOpen = expanded === index;
            return (
              <div key={index} className="rounded-2xl border border-gray-100 bg-blue-50/40 shadow-sm">
                {/* Card header */}
                <div className="flex flex-col gap-3 p-4 sm:flex-row sm:items-start sm:justify-between">
                  <div className="flex flex-1 gap-3">
                    <InitialsAvatar name={`${each.member.firstName} ${each.member.lastName}`} />
                    <div className="min-w-0 flex-1">
                      <p className="text-sm font-bold text-[#262673]">
                        {each.member.firstName} {each.member.lastName} ({each.member.id})
                      </p>
                      <p className="text-xs text-gray-400">{moment(each.createdDate).format('llll')}</p>

                      {/* Chips row */}
                      <div className="mt-2 flex flex-wrap items-center gap-1.5">
                        {each.leaveType && each.leaveType.name === "PERMISSION" ? (
                          <span className="flex items-center gap-1.5 rounded-md bg-[#262673] px-2.5 py-1 text-xs font-medium text-white">
                            <MdDateRange size={12} />
                            {moment(each.leaveRequestDetails[0].date).format("YYYY-MM-DD")}{" "}
                            {moment(each.leaveRequestDetails[0].startTime, "hh:mm:ss").format("hh:mm A")}-
                            {moment(each.leaveRequestDetails[0].endTime, "hh:mm:ss").format("hh:mm A")}
                          </span>
                        ) : (
                          <span className="flex items-center gap-1.5 rounded-md bg-[#262673] px-2.5 py-1 text-xs font-medium text-white">
                            <MdDateRange size={12} />
                            {moment(each.startDate).format("YYYY-MM-DD")} - {moment(each.endDate).format("YYYY-MM-DD")}
                          </span>
                        )}

                        <span className="rounded-md border border-red-200 px-2.5 py-1 text-xs font-medium capitalize text-red-500">
                          {each.leaveType.name.toLowerCase().replace(/_/g, ' ')}
                        </span>

                        {each.leaveDayType && (
                          <span className="rounded-md border border-red-200 px-2.5 py-1 text-xs font-medium capitalize text-red-500">
                            {each.leaveDayType.toLowerCase().replace(/_/g, ' ')}
                          </span>
                        )}

                        {each.leaveHalfDayType && (
                          <span className="rounded-md border border-red-200 px-2.5 py-1 text-xs font-medium capitalize text-red-500">
                            {each.leaveHalfDayType.toLowerCase().replace(/_/g, ' ')}
                          </span>
                        )}
                      </div>

                      {each.reason && (
                        <p className="mt-2 text-sm font-medium text-gray-600">{each.reason}</p>
                      )}
                    </div>
                  </div>

                  {/* Status + actions */}
                  <div className="flex shrink-0 items-center gap-2 self-start sm:flex-col sm:items-end">
                    <span className={`rounded-full px-3 py-1 text-xs font-bold text-white ${statusStyles[each.status] || 'bg-[#262673]'}`}>
                      {each.status}
                    </span>

                    <div className="flex items-center gap-1.5">
                      {each.status === "APPROVED" && (
                        <button
                          onClick={() => editLeaveRequest(each.id)}
                          className="flex h-8 w-8 items-center justify-center rounded-full bg-orange-500 text-white transition-colors hover:bg-orange-600"
                          title="Edit"
                        >
                          <IoPencil size={14} />
                        </button>
                      )}
                      <button
                        onClick={() => handleExpandClick(index)}
                        className="flex h-8 w-8 items-center justify-center rounded-full bg-[#262673] text-white transition-transform hover:bg-[#1b1b3a]"
                        title="Expand"
                      >
                        <IoChevronDown size={14} className={`transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`} />
                      </button>
                    </div>
                  </div>
                </div>

                {/* Expanded content */}
                {isOpen && (
                  <div className="border-t border-gray-100 bg-white px-4 py-4">
                    <div className="relative mb-4 inline-block">
                      <button
  onClick={() => {
    setSelectedLeaves(each.leaves);
    setLeaveHistoryOpen(true);
  }}
  className="rounded-lg bg-[#262673] px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-orange-500"
>
  Check Leave History
</button>

                      
                    </div>

                    {/* Timeline */}
                    <div className="relative">
                      {each.leaveRequestApprovals && each.leaveRequestApprovals.length > 0 &&
                        each.leaveRequestApprovals.map((e, i) => {
                          const isLast = i === each.leaveRequestApprovals.length - 1;
                          return (
                            <div key={i} className="relative flex gap-4 pb-6">
                              {/* Connector line */}
                              {!isLast && (
                                <div className="absolute left-[15px] top-8 h-[calc(100%-8px)] w-0.5 bg-gray-200" />
                              )}

                              {/* Dot */}
                              <div className="z-10 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-green-500 text-white shadow-sm">
                                {timelineIcons[e.changedStatus]}
                              </div>

                              {/* Content */}
                              <div className="flex-1 pt-1">
                                <p className="mb-1.5 text-[10px] font-bold uppercase tracking-wide text-gray-400">
                                  {e.changedStatus}
                                </p>
                                <div className="rounded-xl border border-gray-100 bg-gray-50/60 p-3">
                                  <div className="flex items-center gap-2">
                                    <InitialsAvatar
                                      size={28}
                                      name={e.member ? `${e.member.firstName} ${e.member.lastName}` : "U U"}
                                    />
                                    <p className="text-sm font-bold text-[#262673]">
                                      {e.member ? `${e.member.firstName} ${e.member.lastName}` : ""}
                                    </p>
                                  </div>

                                  {e.member && e.member.id === localStorage.getItem("userId") && (
                                    <div className="mt-2 flex gap-2">
                                      <button
                                        onClick={() => approveLeaveRequestActionClick(e.id)}
                                        className="rounded-lg bg-[#262673] px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-blue-800"
                                      >
                                        Approve
                                      </button>
                                      <button
                                        onClick={() => leaveRequestActionClick('REJECT', e.id)}
                                        className="rounded-lg bg-red-500 px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-red-600"
                                      >
                                        Reject
                                      </button>
                                    </div>
                                  )}

                                  {e.reason && e.reason !== "-" && (
                                    <p className="mt-2 text-xs italic text-gray-500">"{e.reason}"</p>
                                  )}

                                  {e.changedTime && (
                                    <p className="mt-1 text-[11px] text-gray-400">{moment(e.changedTime).format('llll')}</p>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* Edit leave request modal */}
      {isEditLeaveRequestOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 backdrop-blur-sm">
          <div className="w-full max-w-[420px] overflow-hidden rounded-2xl bg-white shadow-2xl">
            <LeaveRequestEdit toggleEditLeaveRequest={toggleEditLeaveRequestModal} id={selectedId} />
          </div>
        </div>
      )}

      {/* Leave request action modal */}
      {isLeaveRequestActionOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4 backdrop-blur-sm">
          <div className="w-full max-w-[420px] overflow-hidden rounded-2xl bg-white shadow-2xl">
            <LeaveRequestAction toggleLeaveRequestAction={toggleLeaveRequestActionModal} status={selectedStatus} approvalId={selectedApprovalId} />
          </div>
        </div>
      )}


      <Modal
  open={leaveHistoryOpen}
  onClose={() => setLeaveHistoryOpen(false)}
>
  <ModalDialog
    size="md"
    sx={{
      width: 500,
      maxWidth: "95vw",
      borderRadius: "16px",
      p: 0,
    }}
  >
    <DialogTitle
      sx={{
        bgcolor: "#262673",
        color: "white",
        px: 2,
        py: 1.5,
        borderRadius: "16px 16px 0 0",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      Leave History
      <IconButton
        variant="plain"
        onClick={() => setLeaveHistoryOpen(false)}
        sx={{ color: "white" }}
      >
        <IoClose />
      </IconButton>
    </DialogTitle>

    <DialogContent sx={{ p: 2 }}>
      {selectedLeaves && (
        <Table
          borderAxis="bothBetween"
          stripe="odd"
          hoverRow
        >
          

          <tbody>
            {leaveHistoryRows(selectedLeaves).map(([label, value], index) => (
              <tr key={index}>
                <td>{label}</td>
                <td>{value}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </DialogContent>
  </ModalDialog>
</Modal>
    </div>
  );
}